import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=615f8270"
import script from "./Train.vue?vue&type=script&lang=js"
export * from "./Train.vue?vue&type=script&lang=js"
import style0 from "./Train.vue?vue&type=style&index=0&id=615f8270&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports